<form class="form" [formGroup]="filtersForm" #formElementRef (ngSubmit)="onSubmit()">
  <p class="label-message" [translate]="searchType === SearchType.AGENT ? 'search-page.search-agent' : 'search-page.search-office'"></p>
  <app-input name="searchInputText"
            [formControl]="filtersForm.controls['searchInputText']"
            [parentFormGroup]="filtersForm"
             inputId="searchPage-input-text"
             placeholder="{{'search-page.placeholder' | translate }}">
    <button class="btn search-btn full-height has-pos-abs is-flex has-flex-align-center has-flex-content-center" type="submit">
      <svg ngNonBindable version="1.1" width="18px" height="18px" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(-14 -122)" fill="none" fill-rule="evenodd">
          <g transform="translate(7 87)">
            <g transform="translate(16 43.769) scale(-1 1) translate(-9 -8.7692)">
              <ellipse cx="10.703" cy="7.1041" rx="5.6262" ry="5.7742" fill="#004E9B" opacity=".3"/>
              <path d="m10.685 12.998c-1.53 0-2.9178-0.63-3.9323-1.6532-0.0013846 0-0.0018462-0.0047368-0.0032308-0.0047368-0.0023077 0-0.0055385-0.0047368-0.0078462-0.0047368-1.0338-1.0468-1.6768-2.5011-1.6768-4.1021 0-3.1832 2.5214-5.7695 5.6202-5.7695 3.0988 0 5.6202 2.5863 5.6202 5.7695 0 3.1784-2.5214 5.7647-5.6202 5.7647zm0-12.955c-3.8622 0-7.0048 3.2258-7.0048 7.1905 0 1.7432 0.60969 3.3442 1.62 4.59l-4.7774 4.9026c-0.27046 0.27947-0.27046 0.72474 0 1.0042 0.13523 0.13737 0.31246 0.20842 0.48969 0.20842 0.17723 0 0.354-0.071053 0.48923-0.20842l4.7857-4.9121c1.2032 0.99947 2.7328 1.6011 4.3975 1.6011 3.8626 0 7.0048-3.2258 7.0048-7.1858 0-3.9647-3.1422-7.1905-7.0048-7.1905z" fill="#fff"/>
            </g>
          </g>
        </g>
      </svg>
    </button>
    <a *ngIf="screenSize === SCREEN_SIZE.MOBILE_ONLY" (click)="openFilters()" class="show-filter hide-on-tablet-up is-flex has-flex-align-center">{{ 'search-page.filter' | translate}}
      <i class="material-icons">chevron_right</i>
    </a>
  </app-input>


  <ng-container *ngIf="screenSize !== SCREEN_SIZE.MOBILE_ONLY">
    <app-select id="filtersSearch-select-realEstateType" [options]="realEstateTypeOptions"
                [placeholder]="'filters.search-filters.any-real-estate-type' | translate"
                [formControl]="filtersForm.controls['realEstateType']"
                [parentFormGroup]="filtersForm">
    </app-select>


    <app-select id="filtersSearch-select-language" [options]="languageOptions"
                [placeholder]="'filters.search-filters.any-language' | translate"
                [formControl]="filtersForm.controls['language']"
                [parentFormGroup]="filtersForm">
    </app-select>

    <div class="pseudo-dropdown show-more-dd" #moreDropdownElement>
      <button id="filtersSearch-button-more" (click)="closeDropdowns('showMore', !showMore)" class="btn-link has-pos-rel select-wrapper is-flex">
        {{ 'more' | translate }}
        <i class="material-icons dropdown-caret">{{ showMore ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
      </button>
      <div class="dropdown-content" [class.hidden]="!showMore">

        <app-select id="filtersSearch-select-speciality" [options]="specialtyOptions"
                    [placeholder]="'filters.search-filters.any-specialty' | translate"
                    [formControl]="filtersForm.controls['specialty']"
                    [parentFormGroup]="filtersForm">
        </app-select>
        <hr/>
        <p>
          <b translate="filters.office.proud-supporter"></b>
        </p>
        <hr/>
        <app-checkbox id="filtersSearch-checkbox-childrenMiracleNetwork" [text]="'filters.office.childrens-miracle-network' | translate"
                      [formControl]="filtersForm.controls['childrensMiracleNetwork']"
                      [parentFormGroup]="filtersForm">
        </app-checkbox>
        <hr/>
        <button id="filtersSearch-button-applyFilters" class="btn btn-secondary btn-full-sized" role="button" translate="filters.apply" (click)="closeDropdowns('showMore', !showMore)"></button>
      </div>
    </div>

    <button class="btn-link reset" (click)="onReset()">
      <img [src]="'/assets/icons/filters/Reset_icon@1x.svg' | staticp" [alt]="'filters.reset' | translate" width="15px" height="16px">
      {{ 'filters.reset' | translate }}
    </button>
  </ng-container>
</form>
